import React from "react"
import "./TopPick.css"

const TopPick = props => (
  <div className="TopPick">
    <div className="TopPick-Context">
      <h3 className="TopPick-Title">{props.title}</h3>
      {props.items}
    </div>
    <div className="TopPick-Banner">
      <a className="TopPick-Button" href="/">
        See deal
      </a>
      <img src={props.img} className={props.banner} alt={props.title} />
    </div>
  </div>
)

export default TopPick